import { DeadSpace } from '@fullstory/client-api';
import { AppendOnlyList, IterableList } from '@fullstory/util/collections';
import { isEqual } from 'lodash';

export class DeadSpaceListModel extends AppendOnlyList<DeadSpace> {
  private _previouslyAdded: Record<number, Readonly<DeadSpace>[]> = {};

  constructor(initializer?: DeadSpace[]) {
    super();

    // NOTE: this method _can't_ call super(initializer) directly because the super constructor
    // calls `append()` before the `_timeline` member can be initialized and throws an error.
    // The same thing happens if the `constructor()` is omitted.
    if (initializer) {
      this.append(initializer);
    }
  }

  append(sequence: IterableList<DeadSpace>): void {
    const filteredSequence: DeadSpace[] = [];

    for (const ds of sequence) {
      const prevDeadSpaceAtTime = this._previouslyAdded[ds.Start] ?? [];
      const isDuplicateEntry = prevDeadSpaceAtTime.some(prevDs => isEqual(prevDs, ds));
      // NB: duplicate detection prevents us from adding the same dead space twice if we fetch data twice
      // or create a fake dead space for Go Live mode.
      if (isDuplicateEntry) {
        continue;
      }

      this._previouslyAdded[ds.Start] = prevDeadSpaceAtTime.concat(ds);
      filteredSequence.push(ds);
    }

    super.append(filteredSequence);
  }
}
